<template>
  <div id="app">
    <router-view v-if="!ajaxing" />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      ajaxing: true,
    };
  },
  beforeCreate: function () {
    this.$store.dispatch("loginAuth").then((data) => {
      this.ajaxing = false;
    });
  },
};
</script>

<style>
  .v-application {
    font-family: BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif !important;
}
</style>